
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { TokenInterceptor } from "app/authorized-http.service";
import { UtilsService } from "app/services/utils.service";
import {MTemplateDataResource} from "app/models/MTemplateDataResource";
import { TagListResource } from "app/models/TagListResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";
import { MTemplateDataFileListResource } from 'app/models/MTemplateDataFileListResource';
import { MTemplateDataFileResource } from 'app/models/MTemplateDataFileResource';
import { MTemplateDataListResource } from 'app/models/mtemplate-data-list-resource';

@Injectable()
export class AddNewsletterService {

 constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

 saveNewsletter(url, body): Observable<MTemplateDataResource> {
  return this.http.post<MTemplateDataResource>(environment['url'] + url, body)
}

getNewsletterTemplate(url): Observable<MTemplateDataResource> {
  return this.http.get<MTemplateDataResource>(environment['url'] + url)
}


  getAllTags(url): Observable<TagListResource> {
    return this.http.get<TagListResource>(environment['url'] + url)
  }

  uploadDoc(url, body): Observable<any> {
		return this.http.post<any>(url, body)
  }

  getDocumentList(url): Observable<MTemplateDataFileListResource> {
		return this.http.get<MTemplateDataFileListResource>(environment['url'] + url)
  }

  deleteDoc(url): Observable<MTemplateDataFileResource> {
		return this.http.get<MTemplateDataFileResource>(environment['url'] + url)
	}
  
  multipleDeleteDocuments(url, body): Observable<MTemplateDataListResource> {
		return this.http.post<MTemplateDataListResource>(url, body)
  }
  
}
